import { DeliveredOrdersType } from 'b2b-common/core/account/api/DeliveredOrders.types';
import {
  CLEAR_DELIVERED_ORDERS_SEARCH,
  DELIVERED_ORDERS_SEARCH,
  DELIVERED_ORDERS_SEARCH_FULFILLED,
  DELIVERED_ORDERS_SEARCH_REJECTED,
} from './actionTypes';
import {
  ClearDeliveredOrdersSearchAction,
  DeliveredOrdersSearchAction,
  DeliveredOrdersSearchFulfilledAction,
  DeliveredOrdersSearchRejectedAction,
} from './types';

const deliveredOrdersSearch = (searchQuery: string): DeliveredOrdersSearchAction => ({
  type: DELIVERED_ORDERS_SEARCH,
  payload: {
    searchQuery,
  },
});

const deliveredOrdersSearchFulfilled = (
  response: DeliveredOrdersType,
): DeliveredOrdersSearchFulfilledAction => ({
  type: DELIVERED_ORDERS_SEARCH_FULFILLED,
  payload: {
    data: response,
  },
});

const deliveredOrdersSearchRejected = (
  error: ErrorType,
): DeliveredOrdersSearchRejectedAction => ({
  type: DELIVERED_ORDERS_SEARCH_REJECTED,
  payload: {
    error,
  },
});

const clearDeliveredOrdersSearch = (): ClearDeliveredOrdersSearchAction => ({
  type: CLEAR_DELIVERED_ORDERS_SEARCH,
});

export {
  clearDeliveredOrdersSearch,
  deliveredOrdersSearch,
  deliveredOrdersSearchFulfilled,
  deliveredOrdersSearchRejected,
};
